var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Map } from 'immutable';
import { ConnectionsList } from "../../ConnectionsList";
import { CreateConnectionPanel } from "../../Connections";
import { CurrentLocationLink, Icon } from "../../Layout";
import { RelationshipsFormButtons } from "../../Relationships";
import { Translate, I18NLink } from "../../I18N";
import { actions } from "../../BasicReducer";
import AddEntitiesPanel from "../../Relationships/components/AddEntities";
import ContextMenu from "../../ContextMenu";
import Footer from "../../App/Footer";
import Marker from "../utils/Marker";
import RelationshipMetadata from "../../Relationships/components/RelationshipMetadata";
import ShowIf from "../../App/ShowIf";
import { NeedAuthorization } from "../../Auth";
import { FeatureToggle } from "../../components/Elements/FeatureToggle";
import V2NewRelationshipsBoard from "../../Entities/components/V2NewRelationshipsBoard";
import { PaginatorWithPage } from "./Paginator";
import { addReference as addReferenceAction } from "../actions/referencesActions";
import {
  loadDefaultViewerMenu,
  loadTargetDocument as loadTargetDocumentAction } from "../actions/documentActions";

import { openPanel } from "../actions/uiActions";
import { selectDoc } from "../selectors";
import ConfirmCloseForm from "./ConfirmCloseForm";
import ViewMetadataPanel from "./ViewMetadataPanel";
import ViewerDefaultMenu from "./ViewerDefaultMenu";
import ViewerTextSelectedMenu from "./ViewerTextSelectedMenu";
import SourceDocument from "./SourceDocument";
import TargetDocument from "./TargetDocument.js";
import determineDirection from "../utils/determineDirection";
import { OCRStatus } from "./OCRStatus";

class Viewer extends Component {
  constructor(props) {
    super(props);
    this.state = { firstRender: true };
    this.handlePlainTextClick = this.handlePlainTextClick.bind(this);
  }

  componentDidMount() {
    const { store } = this.context;
    const { sidepanelTab } = this.props;
    store.dispatch(openPanel('viewMetadataPanel'));
    if (sidepanelTab === 'connections') {
      store.dispatch(actions.set('viewer.sidepanel.tab', ''));
    }
    store.dispatch(loadDefaultViewerMenu());
    Marker.init('div.main-wrapper');
    this.setState({ firstRender: false }); // eslint-disable-line react/no-did-mount-set-state
  }

  handlePlainTextClick() {
    const { showTab } = this.props;
    showTab('metadata');
  }

  prepareClassName(includeFooter) {
    const { panelIsOpen, targetDoc, showConnections } = this.props;
    let className = 'document-viewer with-header';
    className += panelIsOpen ? ' with-panel is-active' : '';
    className += targetDoc ? ' show-target-document' : '';
    className += showConnections ? ' connections' : '';
    className += includeFooter ? ' with-footer' : '';
    return className;
  }

  renderNoDoc() {
    const { doc } = this.props;
    return /*#__PURE__*/(
      _jsx("div", { className: "row" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "content-header content-header-document" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "content-header-title" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "lightbulb" }), /*#__PURE__*/
      _jsx(Translate, {}, void 0, "This entity has no document, you probably want to see the metadata"

      ), "\xA0", /*#__PURE__*/

      _jsx(I18NLink, { to: `/entity/${doc.get('sharedId')}` }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "view")
      )
      )
      )
      ));

  }

  render() {
    const {
      doc,
      sidepanelTab,
      targetDoc,
      changePage,
      onPageChange,
      onDocumentReady,
      addReference,
      loadTargetDocument,
      panelIsOpen,
      showTextSelectMenu,
      file,
      user
    } = this.props;
    const { firstRender } = this.state;
    if (doc.get('_id') && !doc.get('documents').size) {
      return this.renderNoDoc();
    }
    const includeFooter = user.get('_id') && sidepanelTab === 'relationships';
    const className = this.prepareClassName(includeFooter);
    const { raw, searchTerm, pageText, page } = this.props;
    const documentTitle = doc.get('title') ? doc.get('title') : '';

    return /*#__PURE__*/(
      _jsx("div", { className: "row" }, void 0, /*#__PURE__*/
      _jsx(Helmet, {}, void 0, /*#__PURE__*/
      _jsx("title", {}, void 0, `${documentTitle} • Page ${page}`)
      ), /*#__PURE__*/
      _jsx(ShowIf, { if: !targetDoc }, void 0, /*#__PURE__*/
      _jsx("div", { className: "content-header content-header-document" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "content-header-title" }, void 0,
      sidepanelTab !== 'relationships' && /*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx(PaginatorWithPage, { totalPages: file.totalPages, onPageChange: changePage }), /*#__PURE__*/
      _jsx(NeedAuthorization, { roles: ['admin', 'editor'] }, void 0, /*#__PURE__*/
      _jsx(FeatureToggle, { feature: "ocr.url" }, void 0, /*#__PURE__*/
      _jsx(OCRStatus, { file: file })
      )
      ), /*#__PURE__*/
      _jsx(CurrentLocationLink, {
        onClick: !raw ? this.handlePlainTextClick : () => {},
        className: "btn btn-default",
        queryParams: { raw: raw || firstRender ? '' : 'true' } }, void 0,

      raw || firstRender ? /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Normal view") : /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Plain text")

      )
      )

      )
      )
      ), /*#__PURE__*/
      _jsx("main", { className: className }, void 0, /*#__PURE__*/
      _jsx("div", { className: "main-wrapper" }, void 0, /*#__PURE__*/
      _jsx(ShowIf, {
        if:
        !['connections', 'relationships', 'newrelationships'].includes(sidepanelTab) &&
        !targetDoc }, void 0,


      raw || firstRender ? /*#__PURE__*/
      _jsx("div", { className: `${determineDirection(file)} raw-text` }, void 0, pageText) : /*#__PURE__*/

      _jsx(SourceDocument, {
        searchTerm: searchTerm,
        onPageChange: onPageChange,
        onDocumentReady: onDocumentReady,
        file: file }
      )

      ), /*#__PURE__*/
      _jsx(ShowIf, { if: sidepanelTab === 'connections' || sidepanelTab === 'relationships' }, void 0, /*#__PURE__*/
      _jsx(ConnectionsList, { hideFooter: true, searchCentered: true })
      ), /*#__PURE__*/
      _jsx(ShowIf, { if: this.props.newRelationshipsEnabled && sidepanelTab === 'newrelationships' }, void 0, /*#__PURE__*/
      _jsx(V2NewRelationshipsBoard, { sharedId: doc.get('sharedId') })
      ), /*#__PURE__*/
      _jsx(TargetDocument, {}), /*#__PURE__*/
      _jsx(Footer, {})
      ),
      includeFooter && /*#__PURE__*/
      _jsx("div", { className: `entity-footer remove-nesting ${panelIsOpen ? 'with-sidepanel' : ''}` }, void 0, /*#__PURE__*/
      _jsx(RelationshipsFormButtons, {})
      )

      ), /*#__PURE__*/
      _jsx(ConfirmCloseForm, {}), /*#__PURE__*/
      _jsx(ViewMetadataPanel, {
        raw: raw || firstRender,
        storeKey: "documentViewer",
        searchTerm: searchTerm,
        file: file }
      ), /*#__PURE__*/
      _jsx(CreateConnectionPanel, {
        containerId: targetDoc ? 'target' : doc.get('sharedId'),
        onCreate: addReference,
        onRangedConnect: loadTargetDocument,
        file: file }
      ),
      sidepanelTab === 'relationships' && /*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx(RelationshipMetadata, {}), /*#__PURE__*/
      _jsx(AddEntitiesPanel, {})
      ), /*#__PURE__*/

      _jsx(ContextMenu, {
        align: `bottom${includeFooter ? '-with-footer' : ''}`,
        overrideShow: true,
        show: !panelIsOpen }, void 0, /*#__PURE__*/

      _jsx(ViewerDefaultMenu, {})
      ), /*#__PURE__*/
      _jsx(ContextMenu, { align: "center", overrideShow: true, show: showTextSelectMenu }, void 0, /*#__PURE__*/
      _jsx(ViewerTextSelectedMenu, { file: file })
      )
      ));

  }
}
Viewer.defaultProps = {
  searchTerm: '',
  raw: false,
  onPageChange: () => {},
  changePage: () => {},
  onDocumentReady: () => {},
  page: 1,
  doc: Map(),
  file: {},
  user: Map({}),
  // relationships v2
  newRelationshipsEnabled: false
};

























Viewer.contextTypes = {
  store: PropTypes.object
};
const mapStateToProps = (state) => {var _state$settings, _state$settings$colle, _state$settings$colle2;
  const { documentViewer } = state;
  const uiState = documentViewer.uiState.toJS();
  return {
    pageText: documentViewer.rawText,
    doc: selectDoc(state),
    panelIsOpen: !!uiState.panel,
    targetDoc: !!documentViewer.targetDoc.get('_id'),
    locale: state.locale,
    sidepanelTab: documentViewer.sidepanel.tab,
    showConnections: documentViewer.sidepanel.tab === 'references',
    showTextSelectMenu: Boolean(
      !documentViewer.targetDoc.get('_id') && uiState.reference && uiState.reference.sourceRange
    ),
    user: state.user,
    // relationships v2
    newRelationshipsEnabled: (_state$settings = state.settings) === null || _state$settings === void 0 ? void 0 : (_state$settings$colle = _state$settings.collection) === null || _state$settings$colle === void 0 ? void 0 : (_state$settings$colle2 = _state$settings$colle.get('features')) === null || _state$settings$colle2 === void 0 ? void 0 : _state$settings$colle2.get('newRelationships')
  };
};
const mapDispatchToProps = (dispatch) =>
bindActionCreators(
  {
    addReference: addReferenceAction,
    loadTargetDocument: loadTargetDocumentAction,
    showTab: (tab) => actions.set('viewer.sidepanel.tab', tab)
  },
  dispatch
);

const ConnectedViewer = connect(mapStateToProps, mapDispatchToProps)(Viewer);
export { ConnectedViewer };